import {Component, Input, OnInit} from '@angular/core';
import {Utils} from "../../utils/utils";
import {NgIf} from "@angular/common";
import {ButtonModule} from "primeng/button";
import {TooltipModule} from "primeng/tooltip";
import {EventBusService, SpinnerLocation} from "../../services/event-bus.service";
import {getIconForFile} from "vscode-icons-js";
import {AttachmentConstants} from "./attachment-constant";
import {finalize, throwError} from "rxjs";
import {ApiService} from "../../services/api.service";
import {AppModule} from "../../app.module";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {catchError} from "rxjs/operators";
import {AppStateService} from "../../services/app.state.service";
import {
  FileExtended
} from "../../main/components/body/components/chat-main/chat-main-prompt/chat-main-prompt.component";

@Component({
  selector: 'app-attachment',
  standalone: true,
  imports: [
    NgIf,
    ButtonModule,
    TooltipModule,
    ProgressSpinnerModule,
  ],
  templateUrl: './attachment.component.html',
  styleUrl: './attachment.component.scss'
})
export class AttachmentComponent implements OnInit {

  @Input() attachment!: FileExtended;

  AttachmentType = AttachmentType;
  Utils = Utils;
  attachmentType: AttachmentType = AttachmentType.Image;

  imageSrc: string = '';
  isLoading: boolean = true;

  constructor(
      private eventBus: EventBusService,
      private stateService: AppStateService,
      private api: ApiService,
  ) {
  }

  getItemIconPath(): string {
    const iconName = getIconForFile(this.attachment.file.name);
    if ( iconName && AttachmentConstants.existedIconTypeFiles.includes(iconName)) {
      return `./assets/icons/${getIconForFile(this.attachment.file.name)}`;
    }
    return './assets/icons/default_file.svg';
  }

  setAttachmentType(attachment: FileExtended): void {
    if (attachment.file.type.includes('image')) {
      this.attachmentType = AttachmentType.Image;
      this.addImage(attachment);
    } else {
      this.attachmentType = AttachmentType.File;
    }
  }

  getAttachmentData(): AttachmentData {
    const attName = this.attachment.file.name.split('.').slice(0, -1).join('.');
    const attExt = this.attachment.file.name.split('.').pop();
    return {
      name: attName,
      extension: attExt,
    }
  }

  addMedia(): void {
    this.isLoading = true;
    this.api.addMedia(this.attachment).pipe(
        catchError((error) => {
          this.deleteAttachment();
          return throwError(() => error);
        }),
        finalize(() => {
          this.isLoading = false;
        })
    ).subscribe((attachmentData) => {
      this.attachment.id = attachmentData.fileId;
      this.stateService.setConversationAttachments(attachmentData);
    })
  }

  addImage(attachment: FileExtended): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.imageSrc = e.target.result;
    }
    reader.readAsDataURL(attachment.file);
  }

  deleteAttachment(): void {
    this.eventBus.deletedAttachment.next(this.attachment);
    this.stateService.deleteAttachment(this.attachment);
  }

  ngOnInit(): void {
    if (this.attachment) {
      this.setAttachmentType(this.attachment);
      this.addMedia();
    }
  }

}

export enum AttachmentType {
  Image,
  File
}

export interface AttachmentData {
  name: string;
  extension: string | undefined;
}
